<template>
  <div class="editor">
    <!-- main editor components -->
    <editor-tabs :project = "project"></editor-tabs>
    <editor-textarea-ace v-show = "true" :project = "project" :tabs = "tabs"></editor-textarea-ace>
  </div>
</template>

<script>

import EditorTabs from './EditorTabs'
import EditorTextareaAce from './EditorTextareaAce'

export default {
  name: 'Editor',
  components: {
    EditorTabs,
    EditorTextareaAce
  },
  props: {
    projectId: String
  },
  watch: {
    '$route': function (oldRoute, newRoute) {
      console.log('changed route')
      console.log(newRoute)
      this.init()
    }
  },
  data () {
    return {
      tabs: {},
      fileEditing: 'main'
    }
  },
  computed: {
    project () {
      return this.$store.state.project
    },
    isRunning () {
      return this.$store.state.isRunning
    }
  },
  methods: {
    init: function () {
      this.$store.dispatch('auth/initialize')
      if (this.$route.name === 'Editor.create') {
        console.log('Editor.create')
        // this.$store.commit('setProject', emptyProject)
        this.$store.dispatch('createProjectWithoutSaving', { })
      } else { // editor load
        console.log('fetchProject')
        if (this.projectid) {
          this.$store.dispatch('fetchProject', this.projectId)
        }
      }
    }
  },
  created () {
    this.init()
  },
  destroyed () {
    this.$store.commit('setEditorConfigProperty', {'isSketchRunning': false})
  },
  beforeDestroy () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

.editor {
  background: @backgroundColor;
  height: 100vh;
  display: grid;
  grid-template-rows: 50px auto;
}

.debug2 {
  position: absolute;
  z-index: 12;

  p {
    background: white;
    padding: 12px;
    margin: 12px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Editor/EditorSimple.vue